
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";

function GetCode ({socket}){
  const [code,setCode] = useState ("");
  const navigate = useNavigate ();
  const location = useLocation ();
  const phone = location.state.phone;
  useEffect (()=>{
    if (!socket)return;

//    socket.on ('message',(data)=>{
//      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
//      if (data.event==='code_send') window.alert(data.data);
//    });
    socket.on ('message',(data)=>{
      const da=JSON.parse(data);
      if (da.verify==true)
      {
        if (da.units!=null && da._id!=null)
        {
            localStorage.setItem('id',da._id);
            localStorage.setItem('phone', phone);
            localStorage.setItem('units', JSON.stringify(da.units));
            localStorage.setItem('select_unit', '0');

            navigate ("/MainApp");


    //      saveData (data);

          }
        }else {
          window.alert ('کد وارد شده اشتباه است')
          navigate ("/GetPhone");
        }
    })



  return () =>{
    socket.off ('message');
  };

},[socket]);


  return (
    <div style={style.container}>
      <div style={style.content}>
        <h2 style={style.text}>
          لطفا کد پیامک را وارد نمایید
        </h2>
        <input style={style.input}
        type="tel"
        placeholder = "------"
        value={code}
        onChange = {(e)=>{setCode (e.target.value)}}/>
      <button style={style.button}
        onClick ={()=>{
          if (code.length==6)
      //      socket.emit ('myCode',{"code":code});
            socket.emit ('myCode',{"phone":phone,"code":code})
          else
            window.alert ('کد وارد شده اشتباه است')

        }}>
         ارسال کد
      </button>
    </div>
    </div>
  );


}
const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default GetCode;
